import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import OutputText from '@ey/canvascoreservices/OutputText';
import {labels} from '../../util/utils';
import styled from 'styled-components';
import Modal from '../CoreWrappers/Modal';
import utilityfunctions from '../../util/utilityfunctions';
import env from '../../util/env';
import {serviceURL, promiseAreas} from '../../util/uiconstants';
import {deleteDelegate} from '../../actions/Delegate/delegateaction';
import {getUserPreferences} from '../../actions/UserPreferences/userpreferencesaction';

const DeleteModal = (props) => {
	const dispatch = useDispatch();
	const userPreferences = useSelector((store) => store.userPreferences);
	const [isSaving, setIsSaving] = useState(false);
	const deleteMember = (member) => {
		setIsSaving(true);
		dispatch(deleteDelegate(env.getBaseURL(serviceURL) + `Users/${userPreferences.userId}/Delegates/${member.userId}`))
			.then(() => {
				props.setShowDeleteModal(false);
				setIsSaving(false);
				let promises = [];
				Promise.all(promises)
					.then(() => {
						if (props.onDeleteSuccess) {
							props.onDeleteSuccess();
							dispatch(getUserPreferences(env.getBaseURL(serviceURL) + 'Users/Me'));
						}
					})
					.catch(() => {});
			})
			.catch((error) => {});
	};

	return (
		<StyledDeleteModalBody>
			<Modal
				show={props.show}
				isLoading={isSaving}
				showButtons={true}
				modalsize={'x-small'}
				title={labels.delegateTitle}
				onHide={() => props.setShowDeleteModal(false)}
				closeTitle={labels.closeLabel}
				modalContainerClass="remove-delegate"
				confirmBtnTitle={labels.remove}
				onOkClick={() => deleteMember(props.selectedUser)}
				closeBtnTitle={labels.cancelLabel}
				isOkDisabled={isSaving}
				isCancelDisabled={isSaving}
				isSaveCreateButtonDisabled={isSaving}
			>
				<StyledDeleteModalBody>
					<OutputText body1 light>
						{utilityfunctions.createRichTextElement(labels.deleteMessage)}
					</OutputText>
					<hr className="hr-line" />
					<section className="delete-grp-wrap">
						<OutputText body2 light>
							{labels.delegateMember}:
						</OutputText>
						<OutputText body2 regular>
							{props.selectedUser.firstName}
						</OutputText>
						<OutputText body2 regular>
							{props.selectedUser.lastName}
						</OutputText>
					</section>
				</StyledDeleteModalBody>
			</Modal>
		</StyledDeleteModalBody>
	);
};
export default DeleteModal;
const StyledDeleteModalBody = styled.section`
	.delete-grp-wrap {
		display: flex;
		align-items: center;
		padding-top: var(--spacing-x-large);
		max-width: 100%;
		gap: var(--spacing-small);
		padding-bottom: var(--px-56);
	}
	.hr-line {
		margin-top: var(--spacing-x-large);
		border: var(--px-1);
		height: var(--px-1);
		background: ${(props) => props.theme.color['grey200']}; //TODO: vars to colors are not defined , it will be replace by var(--grey200);
	}
`;
